import React from 'react';
import { Table, Button, Icon, Segment } from 'semantic-ui-react';
import { FieldArray } from 'formik';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { TableLine, TextInputField, BooleanInputField } from '../inputs';

// Pazaryeri ayarları (tyOptions / n11Options / hbOptions) eskiden tek obje olarak saklanıyordu,
// artık mağaza dizisi. Form her zaman dizi ile çalışır, kayıt da dizi olarak gider;
// okurken eski tek obje formatı da desteklenir.
export function toAccountList(options, defaults = {}) {
	let list = Array.isArray(options) ? options : options ? [options] : [];
	list = _.filter(list, (it) => _.isPlainObject(it));
	if (!list.length) list = [{}];
	return list.map((it) => _.merge({}, defaults, it));
}

// Kaydetmeden önce tamamen boş bırakılmış mağaza satırlarını at.
export function cleanAccountList(accounts, requiredFields = []) {
	return _.filter(accounts, (it) => _.some(requiredFields, (f) => !_.isEmpty(_.trim(it[f] || ''))));
}

export function AccountList(props) {
	const { t } = useTranslation();
	const { name = 'accounts', fields = [], defaults = {} } = props;
	return (
		<FieldArray name={name}>
			{({ push, remove, form }) => {
				const accounts = _.get(form.values, name) || [];
				return (
					<>
						{accounts.map((account, index) => (
							<Segment key={index} style={{ marginBottom: '20px' }}>
								<div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
									<b>
										{t('store')} {index + 1}
										{account && account.name ? ` - ${account.name}` : ''}
									</b>
									<Button
										type="button"
										size="tiny"
										negative
										basic
										icon
										title={t('removeStore')}
										style={{ marginLeft: 'auto' }}
										disabled={accounts.length < 2}
										onClick={() => remove(index)}
									>
										<Icon name="trash" /> {t('remove')}
									</Button>
								</div>
								<Table definition>
									<Table.Header>
										<Table.Row>
											<Table.HeaderCell width={2} />
											<Table.HeaderCell>{t('value')}</Table.HeaderCell>
										</Table.Row>
									</Table.Header>
									<Table.Body>
										{fields.map((field) => (
											<TableLine key={field.name} title={field.title}>
												<TextInputField name={`${name}[${index}].${field.name}`} placeholder={field.placeholder || field.title} />
											</TableLine>
										))}
										<TableLine title={t('Active')}>
											<BooleanInputField name={`${name}[${index}].active`} />
										</TableLine>
									</Table.Body>
								</Table>
							</Segment>
						))}
						<Button type="button" primary basic icon labelPosition="left" onClick={() => push(_.merge({}, defaults))}>
							<Icon name="plus" />
							{t('addStore')}
						</Button>
					</>
				);
			}}
		</FieldArray>
	);
}

export default AccountList;
